export const sortSelectedToTop = (entities, selectedEntities) => {
    const selectedSet = new Set(selectedEntities.map(e => e.entity_name));
    const selected = entities.filter(e => selectedSet.has(e.entity_name));
    const unSelected = entities.filter(e => !selectedSet.has(e.entity_name));
    return [...selected, ...unSelected];
}

export const getFilteredList = (entities = [], term = '') => {
    const normalizedTerm = term.trim().toLowerCase();

    if (!normalizedTerm) return [];

    return (
        entities
            .filter((entity) => entity.label.toLowerCase().includes(normalizedTerm))
            .map((entity) => ({
                ...entity,
                matchScore: entity.label.toLowerCase().indexOf(normalizedTerm),
            }))
            .sort((a, b) => a.matchScore - b.matchScore)
            // eslint-disable-next-line no-unused-vars
            .map(({ matchScore, ...rest }) => rest)
    );
};
